/* eslint-disable import/no-cycle */
import { filters } from '../data/filters.js';
import { pagination } from '../data/pagination.js';

/*
    We have a string full of checked filters, like so -

        '[{id: 1, terms: [2]}{id: 2, terms: [3,4]}]'

    - and we need to use it to determine which filters to turn on and off!

    This involves some annoying regex and string splitting.
*/
export function stringToFilters(originalString) {

    let string = originalString;

    // remove annoying brackets from the string
    string = string.replace(/\[/gm, '');
    string = string.replace(/\]/gm, '');
    string = string.replace(/\}/gm, '');

    const types = string.split('{');

    // todo: this monstrosity needs refactoring
    for (let i = 0; i < types.length; i++) {

        const type = types[i].split('id: ');

        if (type) {

            if (type.length > 1) {

                const typeId = parseInt(type[1].charAt(0), 10);

                const terms = type[1].split('terms: ');

                if (terms.length > 1) {

                    const termIds = terms[1].split(', ');

                    if (termIds.length) {

                        for (let j = 0; j < termIds.length; j++) {

                            for (let k = 0; k < filters.length; k++) {

                                // find the correct filter
                                if (parseInt(filters[k].id, 10) === typeId) {

                                    for (let l = 0; l < filters[k].options.length; l++) {

                                        // find the correct filter option
                                        if (filters[k].options[l].id === termIds[j]) {

                                            // reset our pagination: the results are about to change
                                            pagination.offset = 0;

                                            // change the filter option's 'checked' attribute
                                            filters[k].options[l].checked = true;

                                        }

                                    }

                                }

                            }

                        }

                    }

                }

            }

        }

    }

}
